import { generator } from '../event-listener.js';
export const OnAfterNavigate = generator('onAfterNavigate');
export const OnNavigate = generator('onNavigate');
//# sourceMappingURL=navigable.js.map